export default __webpack_public_path__ + "static/media/Male-5.69a8e746.svg";